import { render, staticRenderFns } from "./Interpret.vue?vue&type=template&id=16f36b8e&scoped=true&"
import script from "./Interpret.vue?vue&type=script&lang=js&"
export * from "./Interpret.vue?vue&type=script&lang=js&"
import style0 from "./Interpret.vue?vue&type=style&index=0&id=16f36b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f36b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f36b8e')) {
      api.createRecord('16f36b8e', component.options)
    } else {
      api.reload('16f36b8e', component.options)
    }
    module.hot.accept("./Interpret.vue?vue&type=template&id=16f36b8e&scoped=true&", function () {
      api.rerender('16f36b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/推運解讀/Interpret.vue"
export default component.exports